import React, { Component, Fragment } from 'react'
import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
  TableRowColumn
} from 'material-ui/Table'
import Undo from 'material-ui/svg-icons/content/undo'
import CircularProgress from '@material-ui/core/CircularProgress'
import ActionDelete from 'material-ui/svg-icons/action/delete'
import IconButton from '@material-ui/core/IconButton'
import ImageEdit from 'material-ui/svg-icons/image/edit'
import { withStyles } from '@material-ui/core/styles'
import Paper from '@material-ui/core/Paper'
import { connect } from 'react-redux'
import { medicationsActions, confirmActions, messageActions } from '../../actions'
import TablePagination from '@material-ui/core/TablePagination'
import Typography from '@material-ui/core/Typography'
import { listTableStyle } from '../../styles'
import TableSortLabel from '@material-ui/core/TableSortLabel'
import { reloadTable } from '../../utils/reloadTable'
import { findPermission, readOnly } from '../../utils/permissions'
import Visibility from '@material-ui/icons/Visibility'

class ListTable extends Component {
  state = {
    debounce: undefined
  }

  componentWillUpdate(newProps) {
    const { pagination, order, fetchMedications, term } = newProps
    const { page, rowsPerPage: perPage } = pagination

    if (reloadTable(newProps, this.props)) {
      const debounce = setTimeout(() => {
        fetchMedications({ page, perPage, order, term })
      }, 700)

      this.setState(state => {
        clearTimeout(state.debounce)
        return { debounce }
      })
    }
    return true
  }

  componentDidMount() {
    const { fetchMedications } = this.props
    fetchMedications()
  }

  handleParsingString(term) {
    var str = term.join(', ')
    return str
  }

  handleChangePage = (event, page) => {
    const { pagination, handleChangePage, fetchMedications, term } = this.props
    handleChangePage(page)
  }

  handleChangeRowsPerPage = event => {
    const perPage = event.target.value
    const { pagination, fetchMedications, handleChangePerPage, term } = this.props
    handleChangePerPage(perPage)
  }

  handleSortTable = column => {
    const { order, changeOrderColumn, changeOrderDirection } = this.props
    if (column === ((order || {}).column || '')) {
      const direction = ((order || {}).direction || 1) === -1 ? 1 : -1
      changeOrderDirection(direction)
    } else {
      changeOrderColumn(column)
    }
  }

  renderActions = medication => {
    const { fetchMedication, deleteMedication, addConfirm, token, restoreMedication } = this.props

    return (
      <Fragment>
        {readOnly('medicamentos', token) &&
          !medication.deletedAt && (
            <IconButton
              onClick={() => {
                fetchMedication(medication._id)
              }}
            >
              <Visibility nativeColor={'rgba(0, 0, 0, 0.87)'} />
            </IconButton>
          )}

        {!!medication.deletedAt && findPermission('medicamentos', token).remover ? (
          <IconButton
            onClick={() => {
              const { changeMessage } = this.props

              addConfirm({
                confirmMessage: 'Confirma a restauração deste medicamento?',
                confirmFunction: () => {
                  restoreMedication(medication._id)
                  changeMessage({ message: 'Restauração realizada com sucesso.' })
                }
              })
            }}
          >
            <Undo />
          </IconButton>
        ) : (
          <Fragment>
            {findPermission('medicamentos', token).editar && (
              <IconButton
                onClick={() => {
                  fetchMedication(medication._id)
                }}
              >
                <ImageEdit />
              </IconButton>
            )}

            {findPermission('medicamentos', token).remover && (
              <IconButton
                onClick={() => {
                  const { changeMessage } = this.props

                  addConfirm({
                    confirmMessage: 'Confirma a exclusão deste medicamento?',
                    confirmFunction: () => {
                      deleteMedication(medication._id)
                      changeMessage({ message: 'Exclusão realizada com sucesso.' })
                    }
                  })
                }}
              >
                <ActionDelete />
              </IconButton>
            )}
          </Fragment>
        )}
      </Fragment>
    )
  }

  render() {
    const { classes, medications = [], loadingMedications, pagination, order = {} } = this.props
    return (
      <Paper className={classes.wrapperTable} elevation={4}>
        {!!loadingMedications && (
          <div className={classes.wrapperLoader}>
            <CircularProgress />
          </div>
        )}
        <Table
          fixedHeader={true}
          wrapperStyle={{
            display: 'flex',
            flexDirection: 'column',
            maxHeight: 'var(--crud-table-height)'
          }}
          width={'990px'}
        >
          <TableHeader
            displaySelectAll={false}
            className={classes.tableHeader}
            adjustForCheckbox={false}
          >
            <TableRow>
              <TableHeaderColumn>
                <TableSortLabel
                  active={((order || {}).column || '') === 'nome'}
                  direction={((order || {}).direction || 1) === 1 ? 'asc' : 'desc'}
                  onClick={() => {
                    this.handleSortTable('nome')
                  }}
                >
                  Nome
                </TableSortLabel>
              </TableHeaderColumn>
              <TableHeaderColumn>
                <TableSortLabel
                  active={((order || {}).column || '') === 'apresentacao'}
                  direction={((order || {}).direction || 1) === 1 ? 'asc' : 'desc'}
                  onClick={() => {
                    this.handleSortTable('apresentacao')
                  }}
                >
                  Apresentação
                </TableSortLabel>
              </TableHeaderColumn>
              <TableHeaderColumn>
                <TableSortLabel
                  active={((order || {}).column || '') === 'laboratorio_id'}
                  direction={((order || {}).direction || 1) === 1 ? 'asc' : 'desc'}
                  onClick={() => {
                    this.handleSortTable('laboratorio_id')
                  }}
                >
                  Laboratório
                </TableSortLabel>
              </TableHeaderColumn>
              <TableHeaderColumn>
                <TableSortLabel
                  active={((order || {}).column || '') === 'classificacaoMedicamento_id'}
                  direction={((order || {}).direction || 1) === 1 ? 'asc' : 'desc'}
                  onClick={() => {
                    this.handleSortTable('classificacaoMedicamento_id')
                  }}
                >
                  Classificação
                </TableSortLabel>
              </TableHeaderColumn>
              <TableHeaderColumn style={{ width: '100px' }}>Ações</TableHeaderColumn>
            </TableRow>
          </TableHeader>
          <TableBody displayRowCheckbox={false}>
            {(medications || []).length ? (
              (medications || []).map(medication => {
                return (
                  <TableRow key={medication._id}>
                    <TableRowColumn>{medication.nome}</TableRowColumn>
                    <TableRowColumn>{medication.apresentacao}</TableRowColumn>
                    <TableRowColumn>{(medication.laboratorio_id || {}).nome}</TableRowColumn>
                    <TableRowColumn>
                      {(medication.classificacaoMedicamento_id || {}).nome}
                    </TableRowColumn>
                    <TableRowColumn style={{ width: '100px' }}>
                      {this.renderActions(medication)}
                    </TableRowColumn>
                  </TableRow>
                )
              })
            ) : (
              <TableRow>
                <TableRowColumn>
                  <Typography noWrap style={{ textAlign: 'center', padding: '16px' }}>
                    {!!loadingMedications ? 'Carregando...' : 'Não há registros.'}
                  </Typography>
                </TableRowColumn>
              </TableRow>
            )}
          </TableBody>
        </Table>
        <div className={classes.paginationWrapper}>
          <div className={classes.page}>Página: {pagination.page + 1}</div>
          <TablePagination
            component="div"
            className={classes.pagination}
            labelRowsPerPage="Itens por página"
            labelDisplayedRows={({ from, to, count, page }) => {
              return `Exibindo de ${from} a ${to} de ${count}`
            }}
            rowsPerPageOptions={[25, 50, 100]}
            count={pagination.length}
            rowsPerPage={pagination.rowsPerPage}
            page={pagination.page}
            backIconButtonProps={{
              'aria-label': 'Página anterior'
            }}
            nextIconButtonProps={{
              'aria-label': 'Próxima página'
            }}
            onChangePage={this.handleChangePage}
            onChangeRowsPerPage={this.handleChangeRowsPerPage}
          />
        </div>
      </Paper>
    )
  }
}

const mapStateToProps = state => {
  return {
    medication: state.medications.medication,
    medications: state.medications.medications,
    loadingMedications: state.medications.loadingMedications,
    token: state.auth.token,
    pagination: state.medications.medicationsPagination,
    order: state.medications.order,
    term: state.searchTable.term
  }
}

const mapDispatchToProps = dispatch => {
  return {
    openModal: () => {
      dispatch(medicationsActions.openModal())
    },
    closeModal: () => {
      dispatch(medicationsActions.closeModal())
    },
    fetchMedication: id => {
      dispatch(medicationsActions.fetchMedication(id))
    },
    fetchMedications: options => {
      dispatch(medicationsActions.fetchMedications(options))
    },
    deleteMedication: id => {
      dispatch(medicationsActions.deleteMedication(id))
    },
    addConfirm: ({ confirmMessage, confirmFunction }) => {
      dispatch(confirmActions.addFunction({ confirmMessage, confirmFunction }))
    },
    changeMessage: ({ message }) => {
      dispatch(messageActions.changeMessage({ message }))
    },
    handleChangePage: page => {
      dispatch(medicationsActions.handleChangePage(page))
    },
    handleChangePerPage: perPage => {
      dispatch(medicationsActions.handleChangePerPage(perPage))
    },
    restoreMedication: id => {
      dispatch(medicationsActions.restoreMedication(id))
    },
    changeOrderColumn: column => {
      dispatch(medicationsActions.changeOrderColumn(column))
    },
    changeOrderDirection: direction => {
      dispatch(medicationsActions.changeOrderDirection(direction))
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(listTableStyle)(ListTable))



// WEBPACK FOOTER //
// ./src/containers/Medications/ListTable.js